// Module
var code = "<md-input-container>\r\n    <label></label>\r\n    <input type=\"text\" ng-model-options=\"{updateOn: 'blur'}\" />\r\n</md-input-container>";
// Exports
module.exports = code;